export default __webpack_public_path__ + "static/media/20200926_145815.617f6e96.jpg";